module.exports = __webpack_public_path__ + "img/Logo-house.8398e552.png";